export enum PayFreqEnum {
  weekly = 1,
  fortnightly = 2,
  monthly = 3,
}
